// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__CDKy0","imageUploader":"EGiftCard_imageUploader__3HqlY"};